import React, { useEffect } from "react";

const GNX3Script = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.innerHTML = `(() => {
    console.log('[GNX-3] v1');

    const selector = '.best-product';

    const addTrackingScript = () => {
        setTimeout(() => {
                const trackingElements = document.querySelectorAll('.gnx-3-tracking-el');

                trackingElements.forEach((el) => {
                    el.addEventListener('click', () => {
                        const trackingValue = el.getAttribute('data-for-tracking') || '';
                        window.dataLayer.push({
                            event: "GA4event",
                            "ga4-event-name": 'cro_event',
                            "ga4-event-p1-name": 'event_category',
                            "ga4-event-p1-value": 'GNX3_CarouselEngagment',
                            "ga4-event-p2-name": 'event_label',
                            "ga4-event-p2-value": trackingValue,
                        });
                    });
                });
        }, 1500);
    };

    const styles = \`
        .gnx-3-main-title {
            color: #000;
            font-family: Maison,-apple-system,BlinkMacSystemFont,Helvetica Neue,Helvetica,sans-serif !important;
            font-size: 40px !important;
            font-style: normal;
            font-weight: 700 !important;
            line-height: normal !important;
            margin-top: 35px !important;
            padding-top: 50px;
            border-top: 1px solid #000;
            letter-spacing: 0.1px !important;
            margin-bottom: 35px !important;
        }
        .swiper {
            width: 100%;
            margin: 20px auto 0 auto;
            cursor: pointer;
        }
        .swiper-slide {
            // height: 390px !important;
            display: flex !important;
            flex-direction: column;
        }
        .gnx-3-img-a {
            border-color: transparent !important;
        }
        .gnx-3-img {
            max-height: 220px;
        }
        .gnx-3-content {
            height: -webkit-fill-available;
            height: 100%;
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
        .gnx-3-content h3 {
            font-family: Maison,-apple-system,BlinkMacSystemFont,Helvetica Neue,Helvetica,sans-serif !important;
            font-size: 17px;
            font-style: normal;
            font-weight: 700;
            line-height: 20px;
            color: #000;
            margin: 5px 5px 15px 0;
        }
        .gnx-3-content p {
            font-family: Maison,-apple-system,BlinkMacSystemFont,Helvetica Neue,Helvetica,sans-serif !important;
            color: #000;
            font-size: 15px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            margin: 0;
            margin-bottom: 30px; 
        }
        .gnx-3-content a {
            font-family: Maison,-apple-system,BlinkMacSystemFont,Helvetica Neue,Helvetica,sans-serif !important;
            border-radius: 1000px;
            background: #000;
            color: #FFF;
            font-family: "Maison Neue";
            font-size: 12px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            padding: 8px 19px;
            border-color: transparent !important;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            visibility: visible !important;
            opacity: 1 !important;
            z-index: 999 !important;
            position: relative !important;
            cursor: pointer !important;
            pointer-events: auto !important;
        }
        .gnx-3-content div {

        }
        @media (max-width: 1420px) {
            .gnx-3-content h3 {
                font-size: 15px;
            }
            .swiper-slide {
                // height: 360px !important;
            }
        }
        @media (max-width: 768px) {
            .gnx-3-main-title {
                margin-top: 15px !important;
                padding-top: 25px;
                font-size: 36px !important;
                font-weight: 700 !important;
                margin-bottom: 25px !important;
                letter-spacing: 0.2px !important;
            }
            .gnx-3-content h3 {
                font-weight: 700;
                line-height: 20px;
            }
            .gnx-3-content p {
                font-size: 13px;
                font-style: normal;
                font-weight: 400;
            }
            .gnx-3-content a {
                width: 90%;
                font-size: 12px;
            }
        }
        .swiper-pagination-progressbar {
        position: relative !important;
        margin-top: 5px;
        
        }
        .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{
        background:#000 !important;
        }
    \`;

    const insertStylesOnce = (() => {
        let stylesInserted = false;
        return () => {
            if (!stylesInserted) {
                const styleElement = document.createElement('style');
                styleElement.innerHTML = styles;
                document.head.appendChild(styleElement);
                stylesInserted = true;
            }
        };
    })();

    let isUpdateMarkupExecuted = false;
    const updateMarkup = (elementToUpdate) => {
        if (isUpdateMarkupExecuted) return;
        isUpdateMarkupExecuted = true;
        insertStylesOnce();

        const sliderContainer = document.createElement('div');
        sliderContainer.innerHTML = \`
            <h2 class="gnx-3-main-title">Best Sellers</h2>
            <div class="swiper">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <a data-for-tracking="Kids' Pain & Fever Blueberry Flavor" class="gnx-3-tracking-el gnx-3-img-a" href="https://www.genexa.com/products/kids-pain-fever-acetaminophen-liquid">
                            <img class="gnx-3-img" src="https://cdn.shopify.com/s/files/1/0612/5086/3345/files/gnx-3-1.png?v=1739304164" alt="Kids Pain and Fever">
                        </a>
                        <div class="gnx-3-content">
                            <div>
                                <h3>Kids' Pain & Fever Blueberry Flavor</h3>
                                <p>Pain Reliever - Fever Reducer</p>
                            </div>
                            <a role="link" data-for-tracking="Kids' Pain & Fever Blueberry Flavor"  class="gnx-3-tracking-el" href="https://www.genexa.com/products/kids-pain-fever-acetaminophen-liquid">Learn More</a>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <a data-for-tracking="Acetaminophen Extra Strength 50ct"  class="gnx-3-tracking-el gnx-3-img-a" href="https://www.genexa.com/products/acetaminophen-extra-strength-50ct">
                            <img class="gnx-3-img" src="https://cdn.shopify.com/s/files/1/0612/5086/3345/files/gnx-3-2.png?v=1739304164" alt="Acetaminophen Extra Strength">
                        </a>
                        <div class="gnx-3-content">
                            <div>
                                <h3>Acetaminophen Extra Strength 50ct</h3>
                                <p>Pain Reliever - Fever Reducer</p>
                            </div>
                            <a role="link" data-for-tracking="Acetaminophen Extra Strength 50ct"  class="gnx-3-tracking-el" href="https://www.genexa.com/products/acetaminophen-extra-strength-50ct">Learn More</a>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <a data-for-tracking="Kids' Cough & Chest Congestion Blueberry Flavor" class="gnx-3-tracking-el gnx-3-img-a" href="https://www.genexa.com/products/kids-cough-chest-congestion-liquid">
                            <img class="gnx-3-img" src="https://cdn.shopify.com/s/files/1/0612/5086/3345/files/gnx-3-3.png?v=1739304164" alt="Kids' Cough">
                        </a>
                        <div class="gnx-3-content">
                            <div>
                                <h3>Kids' Cough & Chest Congestion</h3>
                                <p>Cough - Mucus - Chest Congestion</p>
                            </div>
                            <a role="link" data-for-tracking="Kids' Cough & Chest Congestion Blueberry Flavor" class="gnx-3-tracking-el" href="https://www.genexa.com/products/kids-cough-chest-congestion-liquid">Learn More</a>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <a data-for-tracking="Antacid Maximum Strength" class="gnx-3-tracking-el gnx-3-img-a" href="https://www.genexa.com/products/antacid-maximum-strength-acid-indigestion-relief-medicine">
                            <img class="gnx-3-img" src="https://cdn.shopify.com/s/files/1/0612/5086/3345/files/gnx-3-4.png?v=1739304164" alt="Antacid Maximum Strength">
                        </a>
                        <div class="gnx-3-content">
                            <div>
                                <h3>Antacid Maximum Strength</h3>
                                <p>Heart burn - Acid Indigestion - Upset Stomach</p>
                            </div>
                            <a role="link" data-for-tracking="Antacid Maximum Strength" class="gnx-3-tracking-el" href="https://www.genexa.com/products/antacid-maximum-strength-acid-indigestion-relief-medicine">Learn More</a>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <a data-for-tracking="Kids' Allergy Diphenhydramine" class="gnx-3-tracking-el gnx-3-img-a" href="https://www.genexa.com/products/kids-diphenhydramine-allergy-liquid">
                            <img class="gnx-3-img" src="https://cdn.shopify.com/s/files/1/0612/5086/3345/files/gnx-3-5.png?v=1739304164" alt="Kids' Allergy">
                        </a>
                        <div class="gnx-3-content">
                            <div>
                                <h3>Kids' Allergy Diphenhydramine</h3>
                                <p>Sneezing - Itchy, Watery Eyes - Runny Nose</p>
                            </div>
                            <a role="link" data-for-tracking="Kids' Allergy Diphenhydramine" class="gnx-3-tracking-el" href="https://www.genexa.com/products/kids-diphenhydramine-allergy-liquid">Learn More</a>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <a data-for-tracking="Cough & Chest Congestion" class="gnx-3-tracking-el gnx-3-img-a" href="https://www.genexa.com/products/cough-chest-congestion">
                            <img class="gnx-3-img" src="https://cdn.shopify.com/s/files/1/0612/5086/3345/files/gnx-3-6.png?v=1739304164" alt="Cough & Chest Congestion">
                        </a>
                        <div class="gnx-3-content">
                            <div>
                                <h3>Cough & Chest Congestion</h3>
                                <p>Cough - Mucus - Chest Congestion</p>
                            </div>
                            <a role="link" data-for-tracking="Cough & Chest Congestion" class="gnx-3-tracking-el" href="https://www.genexa.com/products/cough-chest-congestion">Learn More</a>
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination"></div>
            </div>
        \`;

        elementToUpdate.appendChild(sliderContainer);

        if (!document.getElementById('swiper-css')) {
            const link = document.createElement('link');
            link.id = 'swiper-css';
            link.rel = 'stylesheet';
            link.href = 'https://unpkg.com/swiper@11.2.4/swiper-bundle.min.css';
            document.head.appendChild(link);
        }

        if (typeof Swiper === 'undefined') {
            const script = document.createElement('script');
            script.src = 'https://unpkg.com/swiper@11.2.4/swiper-bundle.min.js';
            script.onload = () => {
                initSwiper();
            };
            document.body.appendChild(script);
        } else {
            initSwiper();
        }

        addTrackingScript();
    };
    
    const initSwiper = () => {
        const swiper = new Swiper('.swiper', {
            loop: false,
            spaceBetween: 10,
            slidesPerView: 2.3,
            breakpoints: {
                768: {
                    slidesPerView: 4,
                }
            },
        pagination: {
            el: '.swiper-pagination', // Make sure this element exists in your HTML
            type: 'progressbar',
            clickable: true
        }
        });
    };

    const observePageURL = () => {
        let pageURL = location.href;
        const observer = new MutationObserver(() => {
            if (pageURL !== location.href) {
                pageURL = location.href;
                if (window.location.pathname.includes('/blog/')) {
                    waitForElement(selector).then((existingElement) => {
                        if (existingElement) {
                            updateMarkup(existingElement);
                        }
                    });
                }
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    };

    const waitForElement = (selector) => {
        return new Promise((resolve) => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }
            const observer = new MutationObserver(() => {
                if (document.querySelector(selector)) {
                    observer.disconnect();
                    resolve(document.querySelector(selector));
                }
            });
            observer.observe(document.body, {
                childList: true,
                subtree: true,
            });
        });
    };

    const initializeTemplate = () => {
        if (window.location.pathname.includes('/blog/')) {
            window.dataLayer.push({
                event: "GA4event",
                "ga4-event-name": 'cro_event',
                "ga4-event-p1-name": 'event_category',
                "ga4-event-p1-value": 'GNX3_TestFired',
                "ga4-event-p2-name": 'event_label',
                "ga4-event-p2-value": 'GNX3 - V1',
            });
    
            const footerEl = document.querySelector('footer');
            if (footerEl) {
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            window.dataLayer.push({
                                event: "GA4event",
                                "ga4-event-name": 'cro_event',
                                "ga4-event-p1-name": 'event_category',
                                "ga4-event-p1-value": 'GNX3_ScrolledToBottom',
                                "ga4-event-p2-name": 'event_label',
                                "ga4-event-p2-value": '',
                            });

                            observer.unobserve(entry.target);
                        }
                    });
                }, { root: null, rootMargin: "0px", threshold: 0.01 });

                observer.observe(footerEl);
            }

            waitForElement(selector).then((existingElement) => {
                if (existingElement) {
                    updateMarkup(existingElement);
                }
            });
            observePageURL();
        }
    };

    initializeTemplate();
})();`;
    document.body.appendChild(script);
  }, []);

  return null;
};

export default GNX3Script;
